<template>
  <div class="qaqc-unified-dashboard qaqc-overview-shimmer" :class="{ 'qaqc-overview-shimmer--tab-only': tabOnly }">
    <template v-if="!tabOnly">
      <div class="qaqc-overview-cards-row">
        <div class="qaqc-summary-cards">
          <div v-for="n in 5" :key="n" class="qaqc-initial-screening-plot-panel">
            <v-skeleton-loader type="image" class="qaqc-shimmer-plot" height="100"></v-skeleton-loader>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <div class="qaqc-overview-tabs-wrap">
        <v-skeleton-loader type="list-item" class="qaqc-shimmer-tabs"></v-skeleton-loader>
      </div>
    </template>

    <div class="qaqc-overview-tab-content-wrap">
      <v-skeleton-loader type="table" class="qaqc-shimmer-table"></v-skeleton-loader>
    </div>

    <div v-if="!tabOnly || showDistribution" class="qaqc-overview-distribution-section">
      <div class="qaqc-initial-screening-plots-layout qaqc-overview-distribution">
        <div class="qaqc-overview-plot-selector qaqc-initial-screening-plot-selector">
          <v-skeleton-loader v-for="i in 4" :key="i" type="list-item" class="qaqc-shimmer-plot-item"></v-skeleton-loader>
        </div>
        <div class="qaqc-overview-plot-panel qaqc-initial-screening-plot-panel">
          <v-skeleton-loader type="image" class="qaqc-shimmer-plot" height="220"></v-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QAQCOverviewShimmer",
  props: {
    tabOnly: { type: Boolean, default: false },
    showDistribution: { type: Boolean, default: true },
  },
};
</script>

